import React, { forwardRef } from 'react';
import Icon from '@xo-union/tk-component-icons';
import styles from './styles.scss';
import { classnames } from '../../helpers/classnames';

interface PillButtonProps {
  children?: string;
  selected: boolean;
  onClick: () => void;
}

export type Ref = HTMLButtonElement;

interface MoreButtonProps {
  numberRemaining: number;
}

export const PillButton = forwardRef<Ref, PillButtonProps>(({ children, selected, onClick, ...rest }, ref) => {
  const classes = classnames(styles.pill, styles.pillButton, {
    [styles['pillButton--selected']]: Boolean(selected),
  });
  return (
    <button ref={ref} className={classes} onClick={onClick} aria-pressed={Boolean(selected)} {...rest}>
      {children}
    </button>
  );
});

export const DismissablePillButton = ({
  children,
  onClick,
  ...rest
}: Omit<PillButtonProps, 'selected'>): JSX.Element => {
  const classes = classnames(styles.pill, styles.dismissablePillButton);
  return (
    <button className={classes} onClick={onClick} aria-label={`Clear ${children}`} {...rest}>
      {children}
      <Icon name="close" size="sm" aria-hidden />
    </button>
  );
};

export const MorePillButton = ({ numberRemaining }: MoreButtonProps): JSX.Element => {
  const classes = classnames(styles.pill, styles.dismissablePillButton, styles.morePill);
  return (
    <button className={classes} aria-label={`${numberRemaining} more filters`}>
      {`+${numberRemaining} more`}
    </button>
  );
};
